export default __webpack_public_path__ + "static/media/project1.6dafcb0a.PNG";